import { Loader2 } from "lucide-react";

const PageLoadingFallback = () => (
  <div className="min-h-screen gradient-hero flex items-center justify-center">
    <Loader2 className="w-8 h-8 animate-spin text-primary" />
  </div>
);

export default PageLoadingFallback;
